import getCheggEnv, { CheggEnv } from '../getCheggEnv';
import getTldFromHostname from './getTldFromHostname';

/**
 * Returns the correct graphql gateway server based on hostname param. The
 * `bff` parameter is used for bff data sources e.g. 'me-web-bff'.
 * @param hostname e.g. "gateway.test.cheggnet.com.mx"
 * @param bff e.g. "me-web-bff"
 * @returns gateway url string
 * e.g. https://gateway.test.cheggnet.com.mx/one-graph/graphql or
 * https://gateway.test.cheggnet.com.mx/me-web-bff/graphql
 */
export default function getGqlUrl(hostname, bff, source) {
  var tld = getTldFromHostname(hostname, source);
  if (getCheggEnv() === CheggEnv.PROD) {
    return "https://gateway.chegg".concat(tld, "/").concat(bff || 'one-graph', "/graphql");
  }
  return "https://gateway.test.cheggnet".concat(tld, "/").concat(bff || 'one-graph', "/graphql");
}